import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  API_ROOT_URL,
  ArchModule,
  AUTH_TOKEN_NAME,
  AUTO_CATCH_CONFIG,
  HttpErrorHandler,
  HttpErrorInterceptor,
  HttpErrorMessageHandler,
  InterceptorConfig,
  LOGIN_ROUTE,
} from '@homeleite/arch';
import { DomainModule } from '@homeleite/domain';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { authTokenKeyFor, currentApiEnvKey, currentApiEnvironment } from './api-environments';
import { UnauthorizedHttpErrorHandler } from './unauthorized-http-error.handler';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule, DomainModule, ArchModule],
  providers: [
    { provide: AUTH_TOKEN_NAME, useFactory: () => authTokenKeyFor(currentApiEnvKey()) },
    { provide: LOGIN_ROUTE, useValue: '/login' },
    { provide: API_ROOT_URL, useFactory: () => currentApiEnvironment().apiRoot },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: AUTO_CATCH_CONFIG, useValue: InterceptorConfig.INTERCEPT },
    UnauthorizedHttpErrorHandler,
    { provide: HttpErrorHandler, useExisting: UnauthorizedHttpErrorHandler, multi: true },
    { provide: HttpErrorHandler, useExisting: HttpErrorMessageHandler, multi: true },
  ],
})
export class CoreModule {}
